import { createRouter, createWebHashHistory } from 'vue-router';
import BoxRoute from "./box";
import CloudRoute from "./cloud";
import DemoRoute from "./demo";
import { getService } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

const routes = getService(environment.nexus, {
    box: BoxRoute,
    cloud: CloudRoute,
    demo: DemoRoute,
});

export default createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    scrollBehavior: (to, from, savedPosition) => savedPosition ?? { top: 0 },
});